<template>
  <div class="plc-header">
    <div class="plc-header-content">
      <div class="header-left">
        <div class="to-home">
          <i></i>
          <span>首页</span>
        </div>
      </div>
      <div class="header-center">
        <div
          @click="jump('plcHome')"
          :class="{ active: pathName === 'plcHome' }"
        >
          商品池
        </div>
        <div
          @click="jump('plcCart')"
          :class="{ active: pathName === 'plcCart' }"
        >
          购物车
          <span class="tip">{{ ecology.total || null }}</span>
        </div>
        <div
          @click="jump('plcOrderList')"
          :class="{ active: pathName === 'plcOrderList' }"
        >
          订单列表
        </div>
      </div>
      <div class="header-right">
        <span>{{ plcUserInfo.defaultCompanyName }}</span>
        <span>{{ plcUserInfo.name }}</span>
        <img class="header-img" :src="plcUserInfo.userAvatarUrl" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      pathName: '',
      plcUserInfo: JSON.parse(sessionStorage.getItem('plcUserInfo') || '{}')
    }
  },
  watch: {
    $route: 'routeHandle'
  },
  computed: {
    ecology () {
      return this.$store.state.ecology
    }
  },
  created () {
    this.routeHandle()
    this.getCurrentUserCount()
    if (!this.bus._events['getCurrentUserCount']) {
      this.bus.$on('getCurrentUserCount', val => {
        this.getCurrentUserCount()
      })
    }
  },
  methods: {
    routeHandle () {
      this.pathName = this.$route.name
    },
    jump (name) {
      this.$router.push({ name })
    },
    getCurrentUserCount () {
      const obj = {
        companyId: this.plcUserInfo.defaultCompanyId,
        defaultCompanyId: this.plcUserInfo.defaultCompanyId
      }
      this.$http.post('/front/oms/plc/shoppingCart/getCurrentUserCount', obj).then(({ data: res }) => {
        if (res.code === 0) {
          this.$store.commit('setTotal', res.data)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.plc-header {
  .plc-header-content {
    width: 1200px;
    height: 66px;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }
  .header-left {
    visibility: hidden;
    .to-home {
      display: flex;
      align-items: center;
      font-size: 16px;
      line-height: 24px;
      color: #1a1a1a;
      cursor: pointer;
      &:hover {
        color: #2a54d1;
      }
    }
    i {
      display: inline-block;
      width: 13px;
      height: 13px;
      background: url(~@/assets/img/plc/left.png) no-repeat;
      background-size: cover;
    }
  }
  .header-center {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    > div {
      position: relative;
      font-size: 16px;
      font-weight: bold;
      color: #666666;
      padding: 9.5px 16px;
      margin: 0 20px;
      cursor: pointer;
      &::after {
        display: block;
        content: ' ';
        width: 100%;
        height: 2px;
        background: transparent;
        position: relative;
        top: 7.5px;
      }
      &:hover,
      &.active {
        color: #2a54d1;
        &::after {
          background: #2a54d1;
        }
      }
    }
    .tip {
      position: absolute;
      top: 0;
      right: 0;
      display: inline-block;
      min-width: 16px;
      line-height: 16px;
      padding: 0 4px;
      background: #ff0000;
      color: #fff;
      box-shadow: 0px 2px 6px 0px rgba(255, 0, 0, 0.3);
      border-radius: 63px;
      font-size: 12px;
      text-align: center;
    }
  }
  .header-right {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 24px;
    span {
      padding: 0 8px;
    }
    .header-img {
      width: 36px;
      height: 36px;
      border-radius: 50%;
    }
  }
}
</style>
